import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';     
@Component({
  selector: 'app-not-found',
  imports: [
    CommonModule, 
  ],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss'
})
export class NotFoundComponent { 
}
